import { gql } from '@apollo/client';

const ProfileSuggestQuery = gql`
  query ProfileSuggestQuery(
    $query: String!
    $first: Int!
    $statisticalAreaIds: [String!]
  ) {
    profileSuggest(
      query: $query
      first: $first
      statisticalAreaIds: $statisticalAreaIds
    ) {
      edges {
        node {
          id
          displayName
          vanityUrlPath
        }
      }
    }
  }
`;

export default ProfileSuggestQuery;
